import script from "./PanelColors.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelColors.vue?vue&type=script&setup=true&lang=js"

import "./PanelColors.vue?vue&type=style&index=0&id=c67c23c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c67c23c0"]])

export default __exports__